import {
    BriefcaseBusiness,
    CalendarDays,
    Car,
    Circle,
    Compass,
    DollarSign,
    Languages,
    MapPin,
    Star,
  } from "lucide-react";
  
  
  function RidesComponent() {
    return (
      <div className="border border-[rgba(85,81,81,0.8)] flex flex-col md:flex-row justify-between items-start md:items-center gap-6 p-4 rounded my-4">
        <img
          src="/images/travel-img.png"
          alt="Google"
          className="rounded w-full md:w-[30%] object-cover"
        />
  
        <div className="flex flex-col w-full md:w-[70%] gap-6 justify-between">
          <div className="flex flex-col sm:flex-row sm:justify-between gap-2">
            <p className="text-[#570033] text-xl font-semibold">Olasunbo Frank</p>
            <span className="flex items-center gap-2 text-sm ">
              <Star className="text-yellow-400" size={18} />
              <p className="text-[#570033] font-medium">4.8</p>
            </span>
  
            <span className="flex items-center gap-2 text-sm ">
              <Circle className="text-[#006F00]" size={18} />
              <p className="text-[#006F00] italic">Available</p>
            </span>
          </div>
  
          <p className="text-[#666666] text-sm leading-relaxed">
            With years of experience and deep local knowledge, I create
            unforgettable journeys rooted in culture, history, and hidden gems.
          </p>
  
          {/* Features Row 1 */}
          <div className="flex flex-col sm:flex-row justify-between gap-10">
            {/* <div className="flex items-center gap-2 text-sm"> */}
            <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
              <Compass />
              <p>5+ years as a certified guide historian</p>
            </div>
            <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
              <Languages />
              <p>French, Yoruba, Efik</p>
            </div>
          </div>
  
          {/* Features Row 2 */}
          <div className="flex flex-col sm:flex-row justify-between gap-10">
            <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
              <BriefcaseBusiness />
              <p>Private & group tours available</p>
            </div>
            <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
              <Car />
              <p>Optional transportation</p>
            </div>
          </div>
  
          {/* Features Row 3 */}
          <div className="flex flex-col sm:flex-row justify-between gap-10">
            <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
              <MapPin />
              <p>Lagos, Nigeria</p>
            </div>
            <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
              <DollarSign />
              <p>$25/hour</p>
            </div>
          </div>
  
          {/* Features Row 4 */}
          <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
            <CalendarDays />
            <p>Available all week</p>
          </div>
  
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-between gap-10">
            <button className="p-2 bg-[#570033] text-white w-full sm:w-[47%] rounded">
              Book Now
            </button>
            <button className="text-[#570033] border border-[#570033] p-2 text-center rounded w-full sm:w-[47%]">
              View Profile
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  export default RidesComponent;
  